<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand to="/">{{site.title}}</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item to="/about">About</b-nav-item>
      </b-navbar-nav>

      <transition name="fade">
        <b-navbar-nav class="justify-content-center navbar-collapse" v-if="user.loggedIn">
          <b-nav-item to="/assets">Assets</b-nav-item>
          <b-nav-item to="/import">Import</b-nav-item>
          <b-nav-item to="/markup">Markup</b-nav-item>
        </b-navbar-nav>
      </transition>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto" v-if="user.loggedIn">
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <em>{{user.details.displayName}}</em>
          </template>
          <b-dropdown-item to="/profile">Profile</b-dropdown-item>
          <b-dropdown-item @click="signOut">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto" v-else>
        <b-navbar-nav>
          <b-nav-item to="/login">Login</b-nav-item>
          <b-nav-item to="/register">Register</b-nav-item>
        </b-navbar-nav>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "@/firebaseConfig";

export default {
  methods: {
    async signOut() {
      try {
        fb.auth
          .signOut()
          .then(() => {
            this.$router.go({ path: "/" });
          })
          .catch(err => console.log("Can't logout: " + err));
      } catch (err) {
        console.log(err);
      }
    }
  },
  computed: {
    ...mapGetters({ user: "user/user", site: "site" })
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>